export function formatPriceWithCurrency(amount: number | null | undefined, currency: string | null | undefined, locale = 'en', decimal?: number) {
  if (amount == null || typeof amount !== 'number' || !Number.isFinite(amount)) {
    return '-';
  }
  
  let localeStr = 'en-US';

  if (locale === 'cs') {
    localeStr = 'cs-CZ';
  } else if (locale === 'fi') {
    localeStr = 'fi-FI';
  }

  const fractionDigits = decimal !== undefined ? { minimumFractionDigits: decimal, maximumFractionDigits: decimal } : { minimumFractionDigits: 0, maximumFractionDigits: 0 };
  
  if (!currency || currency === 'NotDefined') {
    return new Intl.NumberFormat(localeStr, fractionDigits).format(amount);
  }
  
  try {
    return new Intl.NumberFormat(localeStr, {
      style: 'currency',
      currency,
      ...fractionDigits,
    }).format(amount);
  } catch {
    return new Intl.NumberFormat(localeStr, fractionDigits).format(amount);
  }
}